import { z } from 'zod';

export const BanParticipantInput = z.object({
  userId: z.uuid(),
});
export type BanParticipantInput = z.infer<typeof BanParticipantInput>;

export const OrganizerBansQuery = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(50).default(20),
});
export type OrganizerBansQuery = z.infer<typeof OrganizerBansQuery>;

export const OrganizerBanDto = z.object({
  userId: z.uuid(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  username: z.string().nullable(),
  bannedAt: z.iso.datetime(),
  /** Причина из «Отклонить и заблокировать»; null — бан из списка участников. */
  reason: z.string().nullable(),
});
export type OrganizerBanDto = z.infer<typeof OrganizerBanDto>;

export const OrganizerBansResponse = z.object({
  items: z.array(OrganizerBanDto),
  nextCursor: z.string().nullable(),
});
export type OrganizerBansResponse = z.infer<typeof OrganizerBansResponse>;
